export const STATUS_DELAY = {
  NORMAL: "1",
  MINOR: "2", // Delay/Tertunda
  MAJOR: "3" // Down/Gangguan
};
